import React from 'react';
import Herosection from '../components/hero-section';
import ServiceOffer from '../components/Service-offer';
import Company from '../components/company';
import Review from '../components/Review';
import CaseStudy from '../components/caseStudy';
import Build from '../components/Build';
import Development from '../components/development';
import Tech from '../components/Tech';
import Alcaline from '../components/alcalinework';
import Leads from '../components/Lead';
import usePageMeta from '../hooks/usePageMeta';
const Home = () => {
    usePageMeta('Spinnennetz | Top Web Design, Development & CRO Agency', 'Boost your digital presence with Spinnennetz. We offer top-tier web design, development, AI CRO, and e-commerce solutions tailored for your business growth.', '/', {"@context":"https://schema.org","@type":"Organization","name":"Spinnennetz","url":"https://thespinnennetz.com","logo":"https://thespinnennetz.com/spinnennetz-logo.png","description":"Top-tier web design, development, AI CRO, and e-commerce solutions tailored for your business growth."}, 'web design agency, conversion rate optimization services, AI CRO agency, custom ecommerce development, UI/UX design company');
    return (
        <>
            {/* <img src={require('../asstes/bootstrap.svg').default} /> */}
            <Herosection />
            <ServiceOffer />
            <Company />
            <Review />
            <CaseStudy />
            <Build />
            <Development />
            <Tech />
            <Alcaline />
            <Leads />
        </>
    )
}

export default Home;
